import { AxnAdminAvailableUserProperty } from "@idw-types/data/axn-admin-available-user-property";
import { AxnAdminUser, FormattedAxnAdminUser } from "@idw-types/data/axn-admin-user";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";
import { AxnCompany, AxnIdentityProvider, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { getRolesForUserWithIsCustomFlag, organizationUserRolesToString } from "@utils/validation/organization/organization-users/organization-users-util";

export const formatAxnAdminUsers = (
    axnAdminUsers: Array<AxnAdminUser>,
    axnCompanies: Array<AxnCompany>,
    axnIdentityProviders: Array<AxnIdentityProvider>,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnAdminAvailableUserOrganizationProperties: Array<AxnAdminAvailableUserProperty>,
    axnAdminAvailableUserRPProperties: Array<AxnAdminAvailableUserProperty>,
    axnRelyingParties: Array<AxnRelyingParty>
): Array<FormattedAxnAdminUser> => {
    return axnAdminUsers.map(user => formatAxnAdminUser(
        user,
        axnCompanies,
        axnIdentityProviders,
        axnAdminUserPropertyBundles,
        axnAdminAvailableUserOrganizationProperties,
        axnAdminAvailableUserRPProperties,
        axnRelyingParties
    ));
};

export const formatAxnAdminUser = (
    axnAdminUser: AxnAdminUser,
    axnCompanies: Array<AxnCompany>,
    axnIdentityProviders: Array<AxnIdentityProvider>,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle> = [],
    axnAdminAvailableUserOrganizationProperties: Array<AxnAdminAvailableUserProperty> = [],
    axnAdminAvailableUserRPProperties: Array<AxnAdminAvailableUserProperty> = [],
    axnRelyingParties: Array<AxnRelyingParty> = []
): FormattedAxnAdminUser => {
    const roleInfo = getRolesForUserWithIsCustomFlag(
            axnAdminUser,
            axnRelyingParties,
            axnAdminUserPropertyBundles,
            axnAdminAvailableUserOrganizationProperties,
            axnAdminAvailableUserRPProperties
        );
    
    const roles = organizationUserRolesToString(roleInfo);
   
    const organization = axnCompanies.find(c => c.id === axnAdminUser.organizationID);
    const identityProvider = axnIdentityProviders.find(idp => idp.id === axnAdminUser.axnAdminUserDetails?.identityProviderID);
    let createdDate = null;
    if (axnAdminUser.createdDate) {
        createdDate = new Date(parseInt(axnAdminUser.createdDate));
    }

    let modifiedDate = null;
    if (axnAdminUser.modifiedDate) {
        modifiedDate = new Date(parseInt(axnAdminUser.modifiedDate));
    }

    return {
        axnAdminUserDetails: {
            credential: axnAdminUser.axnAdminUserDetails?.credential,
            email: axnAdminUser.axnAdminUserDetails?.email,
            firstName: axnAdminUser.axnAdminUserDetails?.firstName,
            lastName: axnAdminUser.axnAdminUserDetails?.lastName,
            id: axnAdminUser.axnAdminUserDetails?.id,
            identityProvider: identityProvider,
            apiUserName: axnAdminUser.axnAdminUserDetails?.apiUserName,
            apiPassword: axnAdminUser.axnAdminUserDetails?.apiPassword
        },
        axnAdminUserOrganizationProperties: axnAdminUser.axnAdminUserOrganizationProperties,
        axnAdminUserProperties: axnAdminUser.axnAdminUserProperties,
        axnAdminUserRPProperties: axnAdminUser.axnAdminUserRPProperties,
        axnAdminUserPreferences: axnAdminUser.axnAdminUserPreferences,
        canCreateRPService: axnAdminUser.canCreateRPService,
        createdDate: createdDate,
        id: axnAdminUser.id,
        mbun: axnAdminUser.mbun,
        modifiedBy: axnAdminUser.modifiedBy,
        modifiedDate: modifiedDate,
        organization: organization,
        status: axnAdminUser.status,
        permissions: axnAdminUser.permissions,
        roles
    };
};